"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
// Episerver library
const spa_core_1 = require("@episerver/spa-core");
// Modules
const foundation_settings_1 = require("@episerver/foundation-settings");
// Referenced components for configuration
const MoseyLayout_1 = __importDefault(require("./Components/Shared/MoseyLayout"));
const Utils_1 = require("./Utils");
const NotFoundPage_1 = __importDefault(require("./Components/Page/ErrorPage/NotFoundPage"));
const appDebug = false; // process.env.NODE_ENV === 'development';
// Website configuration
exports.Config = {
    // Main setup
    enableDebug: appDebug,
    // Connection details
    basePath: process.env.WEB_PATH,
    // The main URL where Episerver is running.
    get epiBaseUrl() {
        return (0, Utils_1.getHostUrl)() || process.env.EPI_URL;
    },
    defaultLanguage: (0, Utils_1.getLanguage)(),
    // Site layout
    layout: MoseyLayout_1.default,
    notFoundComponent: NotFoundPage_1.default,
    // Spinner section
    // enableSpinner: true,
    // spinner: Loader,
    // spinnerTimeout: 250,
    // Content area configuration
    contentArea: {
        displayOptions: {
            'displaymode-screen': 'displaymode-screen',
            'displaymode-three-quarters': 'col-12 col-md-9',
            'displaymode-two-thirds': 'col-12 col-md-8',
            'displaymode-half': 'col-12 col-md-6',
            'displaymode-one-third': 'col-12 col-md-4',
            'displaymode-one-quarter': 'col-12 col-md-6 col-lg-3',
            'displaymode-one-sixth': 'col-12 col-md-4 col-lg-2'
        },
        defaultRowClass: 'row no-gutters',
        defaultBlockClass: 'col-12',
        defaultContainerClass: 'container',
        containerBreakBlockClass: 'displaymode-screen',
        noWrap: true
    },
    // (Pre)Loading of components, pre-load those components that make up your key landing pages
    preLoadComponents: [
        'app/Components/Image/Media/ImageMediaData',
        'app/Components/NavItem/Block/MenuItemBlock',
        'app/Components/NavItem/Page/LandingPage',
        'app/Components/NavItem/Page/LocationListPage',
        'app/Components/Block/Image/Media/ImageMediaData',
        'app/Components/Block/TextBlock',
        'app/Components/Block/BreadcrumbBlock',
        'app/Components/Block/HeroBlock',
        'app/Components/Block/FooterBlock',
        'app/Components/Block/ContainerBlock',
        'app/Components/Block/PageListBlock',
        'app/Components/Block/TeaserBlock',
        'app/Components/Block/ButtonBlock',
        'app/Components/Block/FormContainerBlock',
        'app/Components/Page/HomePage',
        'app/Components/Page/CmsHomePage',
        'app/Components/Page/LandingPage',
        'app/Components/Page/StandardPage'
    ],
    // List SPA Modules that inject into the bootstrapping process
    modules: [new foundation_settings_1.SettingsInitialization()],
    // List of custom component loaders, app/Components is handled by the core library,
    // so the MoseyComponentLoader is here as example.
    componentLoaders: [
    // MoseyComponentLoader
    ],
    // Configuration of the V2 Content Repository
    iContentRepository: {
        debug: appDebug,
        policy: spa_core_1.ContentDelivery.IRepositoryPolicy.NetworkFirst,
        maxAge: 5
    },
    // Configuration of the V2 Content Delivery API, this overrides the old configuration
    iContentDelivery: {
        Debug: appDebug,
        AutoExpandAll: true
    }
};
exports.Config.componentLoaders.debug = false; // Override global debug to disable debug within the component loaders
exports.default = exports.Config;
